/*
 * @Description:设备地图js
 * @Version: 1.0
 * @Autor: zsw
 * @Date: 2021-08-24 22:18:03
 * @LastEditors: zsw
 * @LastEditTime: 2022-04-22 10:57:06
 */
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import Vector from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import ImageStatic from 'ol/source/ImageStatic';
import * as control from 'ol/control';
import View from 'ol/View';
import axios from 'axios';
import Vue from 'vue';
import infoWindow from './infoWindow';
import {
  Point
} from 'ol/geom';
// import {
//   Tile as TileLayer
// } from 'ol/layer';
import
ImageLayer
from 'ol/layer/Image';
import {
  SecurityManager
}
from '@supermap/iclient-common/security';
import Overlay from 'ol/Overlay';
import {
  TileSuperMapRest
}
  from '@supermap/iclient-ol';
import TileLayer from 'ol/layer/WebGLTile';
import {
  guandaoLayer,
  tmapImage,
  iclientImage,
  boundaryLayer
} from '@/components/MapModules';
import {
  Fill,
  Stroke,
  Icon,
  Style,
  Text
} from 'ol/style';
export default {
  name: 'DeviceMap',
  components: {
    infoWindow,
  },
  data() {
    return {
      showWindow: false,
      highLayer: null,
      tabName: '设备管控',
      map: null,
      lf_hidde: false,
      markerSource: null,
      markerLayer: null,
      deviceList: [],
      winTooltip: null,
      cardActiveName: '作物长势',
      remote_type: 11,
      swiperData: [],
      isMounted: false,
      chartData: {}, // 单一数据
      bottom_hide_btn: false,
      right_hid_btn: false,
      rgBottomHide: true,
      swiperOptions: {
        slidesPerView: 1, // 显示个数
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.swiper-button-next-cus',
          prevEl: '.swiper-button-prev-cus'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      mapPath: null
    }
  },
  created() {
  },
  mounted() {
    this.isMounted = true;
    this.mapPath = 'https://gis-server.chiaic.com/iserver/services/map-HeNanShengWeiXingDiTu/rest/maps/河南省卫星地图_L7_GD_TX';
    this.initMap();
  },
  methods: {
    closeWindow () {
      this.showWindow = false
    },
    sortArray(str) {
      var arr = str.split(',');
      const new_arr = [];
      new_arr.length = arr.length;
      for (let index = 0; index < arr.length; index++) {
        if (index % 2 === 0) {
          new_arr[index + 1] = arr[index];
        } else {
          new_arr[index - 1] = arr[index]
        }
      }
      console.log(new_arr);
      return new_arr
    },
    /* 添加赛诺卫星遥感数据54 */
    getSinoData() {
      axios.get('sino/sinoData_' + this.remote_type + '.json').then((res) => {
        var data = res.data.data[0];
        this.swiper.slideTo(0)
        this.chartData = data;
        this.swiperData = res.data.data
        this.sortArray(data.longitLatInfos)
        var source = new ImageStatic({
          url: data.imgUrl,
          projection: 'EPSG:4326', // 投影
          imageExtent: this.sortArray(data.longitLatInfos)
        })
        this.imgLayer.setSource(source)
      });
    },
    initMap() {
      var that = this;
      that.markerSource = new VectorSource();
      SecurityManager.registerToken('https://gis-server.chiaic.com/iserver/services/map-YY-SZLS/rest/maps/YY_SZLS', '_vErZMuP2k0hhacxy5OhIJHgWQ4teX69OeRWEFBGD31lAyui_RiMrVX7ypSkFco0YMp_TCrI6syePBvbFSKcSA..')
      // 设备图层
      that.markerLayer = new Vector({
        source: that.markerSource
      });
      // 实例化比例尺控件
      var scaleLineControl = new control.ScaleLine({
        // 设置度量单位为米
        units: 'metric',
        target: 'scalebar',
        className: 'ol-scale-line'
      });
      that.highLayer = new TileLayer({
        isGroup: true,
        name: '高精遥感'
      })
      that.imgLayer = new ImageLayer({})
      that.map = new Map({
        target: 'map_container',
        controls: [],
        view: new View({
          center: [112.90737, 33.867405],
          zoom: 7.5,
          // maxZoom: 23,
          projection: 'EPSG:4326'
        }),
        layers: [
          iclientImage('https://gis-server.chiaic.com/iserver/services/map-HeNanShengWeiXingDiTu/rest/maps/%E4%B8%AD%E5%9B%BD%E8%92%99%E6%9D%BF'),
          tmapImage(),
          iclientImage(that.mapPath),
          that.imgLayer,
          that.highLayer,
          that.markerLayer,
        ]
      })
      that.imgLayer.setVisible(false)
      that.highLayer.setVisible(false)
      that.map.addControl(scaleLineControl)
      that.map.on('click', function (evt) {
        console.log(evt);
        var pixel = that.map.getEventPixel(evt.originalEvent);
        that.mapClick(pixel, evt.coordinate);
      })

      that.map.getInteractions().forEach(element => {
        element.setActive(false)//false禁止拖拽，true允许拖拽
      })
      this.getMarkerList()
    },
    getMarkerList () {
      const iconFeature = new Feature({
        geometry: new Point(['113.96775116464', '34.3714442644583']),
        population: 4000,
        name: '设备',
        selected: false,
        obj: {},
        deviceName: 'name',
        rainfall: 500
      });
      var style = new Style({
        image: new Icon({
          anchor: [0.5, 20],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: require(`../../../assets/img/home/coordinates_s.png`)
        })
      });
      iconFeature.setStyle(
        style
      );
      this.markerSource.addFeature(iconFeature);
    },
    // 监听地图点击事件
    mapClick (pixel, tooltipCoord) {
      var that = this;
      var feature = that.map.forEachFeatureAtPixel(pixel, function(feature) {
        return feature;
      });
      if (feature) {
        if (feature.get('name') === '设备') {
          this.showWindow = true
        } else {
          this.showWindow = false
        }
      }
    }
  }
}
